import { all } from 'redux-saga/effects'

import shipments from './shipments/sagas'
import invoices from './invoices/sagas'
import tradeReceivables from './tradeReceivables/sagas'

export default all([shipments, invoices, tradeReceivables])
